/**
 * Returns an incremented number.
 *
 * @param value - The number to increment.
 *
 * @returns The incremented number.
 */
export var increment = function increment(value) {
  return value + 1;
};